/**
 * PasswordInput — input de senha com ícone de olho (mostrar/ocultar) DENTRO
 * do campo. Componente compartilhado para padronizar o comportamento em todo
 * o app (aba DinaBox, primeiro acesso, troca de senha, etc).
 *
 * Usa a classe canônica `.input` do design system; o olho fica absoluto à
 * direita, com cor de ícone neutra (var(--ink-3)).
 *
 * Props: todas as props padrão de <input> (value, onChange, placeholder,
 * autoComplete, disabled, id, name, required, onKeyDown, ...) são repassadas.
 */
import React, { useState } from "react";
import { FiEye, FiEyeOff } from "react-icons/fi";

export default function PasswordInput({
  className = "input",
  autoComplete = "current-password",
  ...rest
}) {
  const [visivel, setVisivel] = useState(false);
  return (
    <div style={{ position: "relative" }}>
      <input
        {...rest}
        className={className}
        type={visivel ? "text" : "password"}
        autoComplete={autoComplete}
        style={{ paddingRight: 42 }}
      />
      <button
        type="button"
        onClick={() => setVisivel((v) => !v)}
        aria-label={visivel ? "Ocultar senha" : "Mostrar senha"}
        title={visivel ? "Ocultar senha" : "Mostrar senha"}
        style={{
          position: "absolute",
          right: 6,
          top: "50%",
          transform: "translateY(-50%)",
          width: 30,
          height: 30,
          border: "none",
          background: "transparent",
          cursor: "pointer",
          display: "grid",
          placeItems: "center",
          color: "var(--ink-3)",
          borderRadius: 6,
          padding: 0,
        }}
      >
        {visivel ? <FiEyeOff size={16} /> : <FiEye size={16} />}
      </button>
    </div>
  );
}
